import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateWeightReal = createAction(ACTION.UPDATE_WEIGHT_REAL.REQUEST);
export const resetError = createAction(ACTION.RESET_ERROR_UPDATE_WEIGHT_REAL_BAG, () => ({}));
